import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

export function createCompanyAddressGroup(fb: FormBuilder): FormGroup {
  return fb.group({
    addressLine1: ["", Validators.required],
    zip: ["", Validators.required],
    city: ["", Validators.required],
    state: ["", Validators.required],
    country: ["", Validators.required],
  });
}

export function createSocialUrlsArray(fb: FormBuilder): FormArray {
  return fb.array([fb.control("")]);
}

export function addSocialUrl(socialUrls: FormArray): void {
  socialUrls.push(new FormControl(""));
}

export function removeSocialUrl(socialUrls: FormArray, index: number): void {
  if (index > 0 && index < socialUrls.length) {
    socialUrls.removeAt(index);
  }
}

export function getFilledSocialUrls(socialUrls: FormArray): string[] {
  return socialUrls.controls
    .map((control) => ((control.value || "") as string).toString().trim())
    .filter((value) => value.length > 0);
}

export function resetCompanyAddress(group: FormGroup): void {
  group.reset({
    addressLine1: "",
    zip: "",
    city: "",
    state: "",
    country: "",
  });
}

export function resetSocialUrls(socialUrls: FormArray, fb: FormBuilder): void {
  while (socialUrls.length > 0) {
    socialUrls.removeAt(0);
  }
  socialUrls.push(fb.control(""));
}
